<template>
    <div class="container">
        <div class="review_hero_unit">
            <div class="operator_review_hero">
                <div class="col-md-5 logo_col" :style="getBrandColor()">
                    <div class="container-fluid">
                        <img class="img-fluid lazyload" :data-src="getBrandImage()" alt=""/>
                    </div>
                </div>
                <div class="col-md-7 bonus_col">
                    <div class="container-fluid">
                        <div class="input-group select-wrap">
                            <p class="select">EDIT LOCATION</p>
                            <div class="box-shadow">
                                <select
                                    class="select2 state-select"
                                    v-model="state"
                                    data-width="100%"
                                    data-placeholder="Please Select Your State"
                                    data-gtm="state-selector-brandproduct-banner"
                                >
                                    <option></option>
                                    <option
                                        v-for="region in supportedRegions"
                                        :key="region.code"
                                        :value="region.code"
                                    >
                                        {{ region.name }}
                                    </option>
                                </select>
                                <div class="map-marker" v-if="!loading">
                                    <svg
                                        width="16px"
                                        height="25px"
                                        viewBox="0 0 16 25"
                                        version="1.1"
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlns:xlink="http://www.w3.org/1999/xlink"
                                        class="icon svg-map-marker"
                                    >
                                        <title>Icon/Pin</title>
                                        <desc>Created with Sketch.</desc>
                                        <g
                                            id="Icon/Pin"
                                            stroke="none"
                                            stroke-width="1"
                                            fill="none"
                                            fill-rule="evenodd"
                                        >
                                            <g
                                                id="Group-5"
                                                transform="translate(0.000000, 0.000000)"
                                                stroke="#000"
                                            >
                                                <path
                                                    d="M11.1219512,8 C11.1219512,9.72409756 9.72409756,11.1219512 8,11.1219512 C6.27590244,11.1219512 4.87804878,9.72409756 4.87804878,8 C4.87804878,6.27590244 6.27590244,4.87804878 8,4.87804878 C9.72409756,4.87804878 11.1219512,6.27590244 11.1219512,8 Z"
                                                    id="Stroke-1"
                                                ></path>
                                                <path
                                                    d="M14.7640976,11.7073171 C15.3939512,10.2876098 15.804878,8.9857561 15.804878,8 C15.804878,3.68936585 12.3106341,0.195121951 8,0.195121951 C3.68936585,0.195121951 0.195121951,3.68936585 0.195121951,8 C0.195121951,8.9857561 0.60604878,10.2876098 1.23590244,11.7073171 L1.79473171,12.8874146 C2.05229268,13.4017561 2.32936585,13.9235122 2.62087805,14.4456585 L8,24.5853659 L13.3338537,14.5276098 C13.6573659,13.950439 13.9644878,13.3732683 14.2470244,12.8050732 L14.7640976,11.7073171 Z"
                                                    id="Stroke-3"
                                                ></path>
                                            </g>
                                        </g>
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <div v-if="displayOffer && defaultOffer && isValidDestinationUrl()">
                            <div class="row">
                                <div class="bonus_desc_col">
                                    <span class="review-offer" v-html="getBrandOffer()"></span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="play_now_row">
                                    <a
                                        :href="
                                            defaultOffer.exit_page.link
                                                | appendfragment(
                                                    'cta',
                                                    'brand_product_review_banner'
                                                )
                                        "
                                        class="play_now_btn exit-page-link"
                                        rel="nofollow"
                                        target="_blank"
                                        :data-gtm="
                                            'brandproduct-banner-' +
                                            brand.brand +
                                            '-state ' +
                                            state.toLowerCase()
                                        "
                                        data-kt="cta:a|ctalocation|operator|product|offer|brand_id|brand_product_id|offer_id|site_offer_id"
                                        data-ctalocation="brand product review banner"
                                        :data-operator="brand.brand"
                                        :data-product="
                                            brand.brand + ' ' + brandProduct.product_type
                                        "
                                        :data-offer="
                                            stripTags(defaultOffer.offer_short_description)
                                        "
                                        :data-brand_id="brand.id"
                                        :data-brand_product_id="defaultProduct.brand_product_id"
                                        :data-offer_id="defaultOffer.offer_id"
                                        :data-site_offer_id="defaultOffer.site_offer_id"
                                    >
                                        {{ ctaText }} <span class="icon-play"></span>
                                    </a>
                                </div>
                            </div>
                            <div class="row operator-product-header-terms-conditions">
                                <span v-html="getTermsAndConditions()"></span>
                            </div>
                        </div>
                        <div v-else>
                            <div class="row" v-if="state">
                                <div class="bonus_desc_col">
                                    <span class="review-offer"
                                    ><em>{{ brand.brand }} {{ brandProduct.product_type }}</em>
                                        is not available in <em>{{ state }}</em></span
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'brand-offer-header',
    props: {
        id: {
            type: Number,
        },
        brand: {
            type: Object,
            required: true,
        },
        ctaText: {
            type: String,
            required: true,
        },
        brandProduct: {
            type: Object,
            default: false,
        },
        offers: {
            type: Array,
            default: false,
        },
        displayOffer: {
            type: Boolean,
            default: true,
        },
        regionData: {
            type: Object,
            required: true,
        },
        geo: {
            type: String,
        },
        defaultRegion: {
            type: String,
        },
        brandProductImage: {
            type: String,
            default: '',
        }
    },
    data() {
        return {
            scope: '#brand-offer-header',
            defaultProduct: {},
            defaultOffer: {},
            state: false,
            loading: false,
            cookieKey: 'op_list_region_' + this.geo.toLowerCase(),
            supportedRegions: this.regionData[this.geo].supported_regions,
        };
    },
    created() {
        var self = this;

        // Check to see if we have a cookie set
        if ($cookies.isKey(this.cookieKey)) {
            this.setState($cookies.get(this.cookieKey));
        } else {
            this.setState(this.defaultRegion);
        }

        // Listen for state selector change
        setTimeout(function () {
            $(self.scope + ' .state-select').on('change', function () {
                if ($(this).val() != self.state) {
                    self.setState($(this).val());
                    window.dataLayer.push({event: 'state-selected', state: self.state});
                }
                // Fire click event for GTM
                $(self.scope + ' .state-select option[value="' + $(this).val() + '"]').trigger(
                    'click'
                );
            });

            // Fire KTAG tracking event
            ktag.reRender();
            
        }, 500);

        // Listen for a state change - Used incase we have multiple op lists on a single page
        $('body').on('vueOpList:setState', function (e, state, scope) {
            // Update this op list state if the change wasn't on this scope
            if (scope != this.scope) {
                self.state = state;

                self.fetchDefaultProductAndOffer();

                $(self.scope + ' select')
                    .val(state)
                    .trigger('change');
            }
        });
    },
    methods: {
        /**
         * Function to remove any htmkl tags from a string of text
         */
        stripTags: function (text) {
            return text.replace(/<\/?[^>]+(>|$)/g, '');
        },
        /**
         * Set the state for an operator list
         */
        setState: function (stateCode) {
            this.state = stateCode;

            // Set our cookie
            $cookies.set(this.cookieKey, this.state);
            $cookies.set('op_list_state', this.state);

            // Fetch the offer data
            this.fetchDefaultProductAndOffer();

            // Fire a trigger to alert the rest of our op lists of this change
            var state = this.state;
            var scope = this.scope;

            $('body').trigger('vueOpList:setState', [state, scope]);
        },
        fetchDefaultProductAndOffer() {
            // Reset objects
            this.defaultProduct = {};
            this.defaultOffer = {};

            this.defaultProduct = this.brandProduct;

            let stateToFind = this.state

            if (['ON', 'AB'].indexOf(stateToFind) === -1) {
                stateToFind = 'AB'
            }

            this.defaultOffer = this.offers.find((offer) => {
                return offer.us_states.some((state) => state.code == stateToFind);
            });

            if (!this.defaultOffer) {
                if (this.geo == 'CA') {
                    // Fallback to Ontario for CA
                    this.defaultOffer = this.offers.find((offer) => {
                        return offer.us_states.some((state) => state.code == stateToFind);
                    });
                }
            }

            if (this.defaultOffer) {
                document.body.dispatchEvent(
                    new CustomEvent('passOfferQuantity', {detail: {offerQuantity: 1}})
                );
                // Fire KTAG tracking event
                ktag.reRender();
            }
        },
        isValidDestinationUrl() {
            return !!this.defaultOffer.destination_url;
        },
        getBrandColor() {
            return this.brandProduct.brand_product_color
                ? {'background-color': this.brandProduct.brand_product_color}
                : null;
        },
        getBrandImage() {
            return this.brandProductImage;
        },
        getTermsAndConditions() {
            if (this.defaultOffer.offer_terms_conditions) {
                return this.defaultOffer.offer_terms_conditions;
            } else {
                return this.defaultProduct.offer_terms_default;
            }
        },
        getBrandOffer() {
            let arrString = [];
            arrString.push(this.defaultOffer.offer_short_description);

            if (this.defaultOffer.promo.code) {
                arrString.push(this.defaultOffer.promo.label + ':');
                arrString.push('<em>' + this.defaultOffer.promo.code + '</em>');
            }

            return arrString.join(' ');
        },
    },
};
</script>
